import { memo } from 'react';
import { Context as ResponsiveContext } from 'react-responsive';

import { breakpoints } from '~/react-utils/breakpoints';

import { FooterNav, type FooterNavProps } from './FooterNav';

export * from './FooterNav';

const ResponsiveFooterNav = ({
	deviceType,
	...props
}: FooterNavProps & { deviceType: string }) => {
	const deviceWidth =
		deviceType === 'MOBILE'
			? breakpoints.phoneSm
			: deviceType === 'TABLET'
				? breakpoints.tablet
				: breakpoints.desktop;

	return (
		<ResponsiveContext.Provider value={{ width: deviceWidth }}>
			<FooterNav {...props} />
		</ResponsiveContext.Provider>
	);
};

export default memo(ResponsiveFooterNav);
